module.exports = __webpack_public_path__ + "img/dancing_panda3.5c2d1cde.gif";